var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var AuditLogEvent = /** @class */ (function (_super) {
    __extends(AuditLogEvent, _super);
    function AuditLogEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List Audit Log events
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/audit-log_event/query
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    AuditLogEvent.prototype.query = function (body) {
        return this.rawQuery(Utils.serializeRequestBody(body, {
            type: 'audit_log_query',
            attributes: ['filter', 'next_token', 'detailed_log'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List Audit Log events
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/audit-log_event/query
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    AuditLogEvent.prototype.rawQuery = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/audit-log-events/query',
            body: body,
        });
    };
    AuditLogEvent.TYPE = 'audit_log_event';
    return AuditLogEvent;
}(BaseResource));
export default AuditLogEvent;
//# sourceMappingURL=AuditLogEvent.js.map